module.exports = __webpack_public_path__ + "static/media/display-1@768.f915e52a.png";